import { render, staticRenderFns } from "./zbrlMapChsPoint.vue?vue&type=template&id=37e2d604"
import script from "./zbrlMapChsPoint.vue?vue&type=script&lang=js"
export * from "./zbrlMapChsPoint.vue?vue&type=script&lang=js"
import style0 from "./zbrlMapChsPoint.vue?vue&type=style&index=0&id=37e2d604&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports